import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { UserUtilityService } from 'src/app/services/user-utility.service';

@Component({
    selector: 'app-management-organization-header',
    templateUrl: './management-organization-header.component.html',
    styleUrls: ['./management-organization-header.component.scss'],
})
export class ManagementOrganizationHeaderComponent implements OnInit {
    ulCSSClasses: string;
    rootArrowEnabled: boolean;
    location: Location;
    headerMenuDesktopToggle: string;
    currentOrgId: string;
    currentInstanceId: string;
    routeid: string;
    isOrganizationVisible: boolean = true;
    isAddOrg: boolean;
    isInstanceVisible: boolean;
    isAddInstance: boolean;

    constructor(
        private activatedRoute: ActivatedRoute,
        private user_utility: UserUtilityService,
        public router: Router
    ) {}

    async ngOnInit(): Promise<void> {
        this.routeid = this.activatedRoute.snapshot.paramMap.get('id');
        this.currentOrgId = localStorage.getItem('selectedOrgId');
        this.currentInstanceId = localStorage.getItem('currentInstanceId');
        //check for menu visible
        this.isOrganizationVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-organization', userActions.View);
        this.isAddOrg = await this.user_utility.checkUserPermissionDataAndRoute('add-organization', userActions.Create);
        this.isInstanceVisible = await this.user_utility.checkUserPermissionDataAndRoute('view-instance', userActions.View);
        this.isAddInstance = await this.user_utility.checkUserPermissionDataAndRoute('add-instance', userActions.Create);
        let router = this.router.url;
    }
}
